<app-loader *ngIf="Loader"></app-loader>
<div class="main flex justify-center items-center ">
    <div class="w-full max-w-4xl px-4 py-8">
        <div class="bg-white text-gray-500 border rounded-3xl shadow-3xl overflow-hidden p-5">
            <div class="md:flex">
                <div class="w-full md:w-1/2 px-6 py-8">
                    <h1 class="font-semibold text-2xl text-slate-800 mb-10">Change Password</h1>

                    <form name="formpassword" #f="ngForm" (ngSubmit)="f.valid && Submit(f)"
                        [appMatchPassword]="['password', 'confirmPassword']" novalidate autocomplete="off">

                        <div class="mb-6">
                            <!-- <label class="block text-sm font-medium text-gray-700">Enter old password
                                <span class="text-red-500 text-xs">*</span>
                            </label> -->
                            <div class="relative mt-1">
                                <input type="{{ hideOldPassword ? 'password' : 'text' }}" [ngClass]="{
                                    'border-red-500': OldNotMatch,
                                    'border-gray-300': !OldNotMatch
                                  }" autocomplete="new-password"
                                    class="w-full px-4 py-2 rounded-lg bg-neutral-100 text-sm border-none placeholder:text-gray-400 text-gray-600 focus:ring-1 focus:ring-gray-400 "
                                    name="oldpassword" (change)="OldPassword($event)"
                                    [(ngModel)]="formpassword.oldpassword" required minlength="8" maxlength="25"
                                    #oldpassword="ngModel"
                                    [ngClass]="{ 'border-red-500': f.submitted && oldpassword.errors }"
                                    placeholder="old password" />

                                <span (click)="toggleOldPasswordVisibility()"
                                    class="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                    <svg *ngIf="!hideOldPassword" class="w-5 h-5 text-gray-500" fill="none"
                                        stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21">
                                        </path>
                                    </svg>
                                        <svg *ngIf="hideOldPassword" class="w-5 h-5 text-gray-500" fill="none"
                                            stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z">
                                            </path>
                                        </svg>
                                </span>
                                <span class="text-red-500 text-xs mt-1 px-3" *ngIf="OldNotMatch">Your old password does
                                    not match</span>
                            </div>

                            <div class="text-red-500 text-xs mt-1 px-3" *ngIf="f.submitted && oldpassword.errors">
                                <div *ngIf="oldpassword.errors['required']">Password is required</div>
                                <div *ngIf="oldpassword.errors['minlength']">Password must be at least 8 characters
                                </div>
                                <div *ngIf="oldpassword.errors['maxlength']">Password must not exceed 25 characters
                                </div>
                            </div>
                            <div *ngIf="errors.oldpassword" class="text-red-500 mt-2">
                                {{ errors.oldpassword }}
                              </div>
                        </div>

                        <div class="mb-6">
                            <div class="relative mt-1">
                                <input type="{{ hidePassword ? 'password' : 'text' }}" autocomplete="off" [ngClass]="{
                                    'border-red-500': f.submitted && password.errors || OldConfirmMatch,
                                    'border-gray-300': !OldConfirmMatch && !(f.submitted && password.errors)
                                  }"
                                    class="w-full px-4 py-2 rounded-lg bg-neutral-100 text-sm border-none placeholder:text-gray-400 text-gray-600 focus:ring-1 focus:ring-gray-400"
                                    name="password" [(ngModel)]="formpassword.password" required minlength="8"
                                    maxlength="25" #password="ngModel" placeholder="New Password" />

                                <span (click)="togglePasswordVisibility()"
                                    class="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                    <svg *ngIf="!hidePassword" class="w-5 h-5 text-gray-500" fill="none"
                                        stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21">
                                        </path>
                                    </svg>
                                    <svg *ngIf="hidePassword" class="w-5 h-5 text-gray-500" fill="none"
                                        stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z">
                                        </path>
                                    </svg>
                                </span>
                            </div>

                            <div class="text-red-500 text-xs mt-1 px-3" *ngIf="f.submitted && password.errors">
                                <div *ngIf="password.errors['required']">New Password is required</div>
                                <div *ngIf="password.errors['minlength']">New Password must be at least 8 characters
                                </div>
                                <div *ngIf="password.errors['maxlength']">New Password must not exceed 25 characters
                                </div>
                            </div>
                            <div class="text-red-500 text-xs mt-1 px-3" *ngIf="OldConfirmMatch">Password should not
                                match New Password</div>
                                <div *ngIf="errors.password" class="text-red-500 mt-2">
                                    {{ errors.password }}
                                  </div>
                        </div>

                        <div class="mb-6">
                            <!-- <label class="block text-sm font-medium text-gray-700">Confirm new password
                                <span class="text-red-500 text-xs">*</span>
                            </label> -->
                            <div class="relative mt-1">
                                <input type="{{ hideConfirmPassword ? 'password' : 'text' }}" autocomplete="off"
                                    class="w-full px-4 py-2 rounded-lg bg-neutral-100 text-sm border-none placeholder:text-gray-400 text-gray-600 focus:ring-1 focus:ring-gray-400"
                                    name="confirmPassword" [(ngModel)]="formpassword.confirmPassword" required
                                    maxlength="25" #confirmPassword="ngModel" placeholder="Confirm Password"
                                    [ngClass]="{ 'border-red-500': f.submitted && confirmPassword.errors }" />

                                <span (click)="toggleConfirmPasswordVisibility()"
                                    class="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                    <svg *ngIf="!hideConfirmPassword" class="w-5 h-5 text-gray-500" fill="none"
                                        stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21">
                                        </path>
                                    </svg>
                                    <svg *ngIf="hideConfirmPassword" class="w-5 h-5 text-gray-500" fill="none"
                                        stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z">
                                        </path>
                                    </svg>
                                </span>

                            </div>

                            <div class="text-red-500 text-xs mt-1 px-3" *ngIf="f.submitted && confirmPassword.errors">
                                <div *ngIf="confirmPassword.errors['required']">Confirm Password is required</div>
                                <div *ngIf="confirmPassword.errors['matching']">Confirm Password does not match</div>
                            </div>
                            <div *ngIf="errors.confirmPassword" class="text-red-500 mt-2">
                                {{ errors.confirmPassword }}
                              </div>
                        </div>

                        <div class="text-center">
                            <button type="submit"
                                class="block w-1/4 max-w-1/4 mx-auto bg-orange-500 hover:bg-orange-600 text-white rounded-lg px-3 py-2 font-semibold focus:outline-none">
                                Submit
                            </button>
                        </div>
                    </form>
                </div>

                <div class="hidden md:block w-1/2 bg-white py-10 px-8">
                    <img src="images/11435046_4706262 1.svg" class="mx-auto" alt="Password Image" />
                </div>
            </div>
        </div>
    </div>
</div>